import styled from 'astroturf';
import React from 'react';

import Footer from  './footer';
import Header from './header';

import 'normalize.css';
import './layout.css';

const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: require("./layout-Container.module.css"),
  attrs: null,
  vars: []
});

const Spacer = /*#__PURE__*/styled("div", null, {
  displayName: "Spacer",
  styles: require("./layout-Spacer.module.css"),
  attrs: null,
  vars: []
});

interface Props {
  children?: React.ReactNode;
  className?: string;
  noFooterMargin?: boolean;
}

const Layout = ({ children, className, noFooterMargin }: Props) => {
  return (
    <Container>
      <Header />
      <main className={className}>{children}</main>
      <Spacer />
      <Footer noMarginTop={noFooterMargin} />
    </Container>
  );
};

export default Layout;
